/* Leefar – click feedback: a pink light ring pulses out from any button.
   The CSS keyframe lives in leefar-custom.css (.lf-ring). Restarting the class
   on every click lets rapid taps replay the ring. */
(function () {
  var SELECTOR = '.button:not(.button-unstyled):not(.dropdown-localization__button), .button-secondary, .button-custom, .lf-tier';

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest(SELECTOR);
      if (!button) return;

      button.classList.remove('lf-ring');
      void button.offsetWidth; // force reflow so the animation restarts
      button.classList.add('lf-ring');
    },
    true
  );

  document.addEventListener(
    'animationend',
    function (event) {
      if (event.animationName === 'lf-ring' && event.target && event.target.classList) {
        event.target.classList.remove('lf-ring');
      }
    },
    true
  );
})();

/* Sticky mobile buy bar: shown once the hero has scrolled away, hidden while
   the buy section itself is on screen. */
(function () {
  var bar = document.querySelector('[data-lf-sticky-buy]');
  var hero = document.querySelector('.shopify-section[id$="__hero"]');
  var buy = document.querySelector('.shopify-section[id$="__product"]');
  if (!bar || !hero || !buy || !('IntersectionObserver' in window)) return;

  var heroVisible = true;
  var buyVisible = false;

  function update() {
    bar.classList.toggle('is-visible', !heroVisible && !buyVisible);
  }

  new IntersectionObserver(
    function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    },
    { threshold: 0.1 }
  ).observe(hero);

  new IntersectionObserver(
    function (entries) {
      buyVisible = entries[0].isIntersecting;
      update();
    },
    { threshold: 0.1 }
  ).observe(buy);
})();
